import { FilterQuery } from "../../../../../microservices/functions/src/types/product_catalog/catalog_api_types";
import isEmpty from "ramda/src/isEmpty";

const ignoredKeys: (keyof FilterQuery)[] = ["categoryId", "sort"];

export const isFilterAdjusted = (filter: FilterQuery): boolean =>
  Object.keys(filter).filter(
    (key) =>
      !ignoredKeys.includes(key as keyof FilterQuery) &&
      !isEmpty(filter[key as keyof FilterQuery])
  ).length > 0;
